import { compose } from 'redux';
import { createSelector } from 'reselect';
import type { VehicleState } from './reducer';

import type { Vehicle } from '@cobliteam/common-types';

import { mapWebData } from '@cobliteam/api-lib';

import type { ISelectOptionType } from '@cobliteam/base-components';

import type { AppState } from '../AppState';

const selectVehiclesDomain = (state: AppState): VehicleState => state.vehicles;

export const selectVehicles = compose((state) => state.vehiclesWebData, selectVehiclesDomain);

const compareVehicles = (vehicleA: Vehicle, vehicleB: Vehicle) => {
  if ((vehicleA.licensePlate || '') < (vehicleB.licensePlate || '')) {
    return -1;
  }
  if ((vehicleA.licensePlate || '') > (vehicleB.licensePlate || '')) {
    return 1;
  }
  if ((vehicleA.model.brand || '') < (vehicleB.model.brand || '')) {
    return -1;
  }
  if ((vehicleA.model.brand || '') > (vehicleB.model.brand || '')) {
    return 1;
  }
  if ((vehicleA.model.name || '') < (vehicleB.model.name || '')) {
    return -1;
  }
  if ((vehicleA.model.name || '') > (vehicleB.model.name || '')) {
    return 1;
  }
  return 0;
};

const getOrdered = (vehicles: Vehicle[]): Vehicle[] => {
  return vehicles.sort(compareVehicles);
};

export const selectVehiclesInOrder = createSelector(selectVehicles, mapWebData(getOrdered));

const getVehicleIdOptions = (vehicles: Vehicle[]): ISelectOptionType[] => vehicles.map((vehicle) => ({ value: vehicle.id, label: vehicle.label }));

export const selectVehicleOptions = createSelector(selectVehiclesInOrder, mapWebData(getVehicleIdOptions));

const getLength = (vehicles: Vehicle[]): number => vehicles.length;
export const selectNumberVehicles = createSelector(selectVehicles, mapWebData(getLength));

export const selectVehiclesById = createSelector(
  selectVehicles,
  mapWebData((vehicles) => new Map(vehicles.map((vehicle) => [vehicle.id, vehicle])))
);

export const selectVehiclesByDeviceId = createSelector(
  selectVehicles,
  mapWebData((vehicles) => new Map(vehicles.map((vehicle) => [vehicle.deviceId, vehicle])))
);

export const selectCreateEtaPageWebData = (state: AppState) => state.vehicles.createEtaPageWebData;
